// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBusinessStatsResponse

export type AdminBusinessStatsApiResponse = {
	mrr: number;
	activeUsers: number;
	revenueThisMonth: number;
	revenueLastMonth: number;
};

export type AdminBusinessStats = {
	mrr: number;
	activeUsers: number;
	revenueThisMonth: number;
	revenueLastMonth: number;
};

export function hydrateAdminBusinessStats(data: AdminBusinessStatsApiResponse): AdminBusinessStats {
	return { ...data };
}